import { Management, ReplaceProducts } from './components';

export { ReplaceProducts, Management };
